import React from 'react';
import { graphql } from 'gatsby';
import Layout from '@components/Layout';
import Filters from '@components/shared/Filters';
import IconTextGrid from '@components/shared/IconTextGrid';
import ProductCatalogue from '@components/storefront/ProductCatalogue';
import { getUSPData } from '@components/storefront/productsUSPsData';
import { getShopProducts } from '@data/storefront';
import { useCountry } from '@hooks/useCountry';
import { filterProducts, applyCountrySpecificSorting } from '@utils/product';

export const query = graphql`
  query ($language: String!) {
    locales: allLocale(filter: { language: { eq: $language } }) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
    allPrismicEcommerceProductCategory(sort: { data: { category_nav_order: ASC } }) {
      nodes {
        data {
          title
        }
        uid
        lang
      }
    }
  }
`;

const Products = ({ data }) => {
  const { country } = useCountry();
  const shopProducts = getShopProducts();
  const filteredProducts = filterProducts(country, shopProducts);
  const products = applyCountrySpecificSorting(country, filteredProducts);
  const { nodes } = data.allPrismicEcommerceProductCategory;

  const SEO = {
    uid: 'products',
    href: '/products/',
    title: 'All Products | Buy Period Products for Vaginal Health | Daye',
    description:
      "View all Daye's products, including eco-friendly period care products such as tampons and pads as well as our at-home vaginal screenings and ProViotics."
  };

  return (
    <Layout SEO={SEO}>
      <Filters products={filteredProducts} categories={nodes} />
      <ProductCatalogue data={products} />
      <IconTextGrid slice={getUSPData()} />
    </Layout>
  );
};

export default Products;
